import React from 'react';

import './InputError.css';

interface Props {
  name: string;
  isFormGroup?: boolean;
  formik: any;
}

const InputError: React.FC<Props> = props => {
  const { isFormGroup, name, formik } = props;

  return (
    <div className="ui-widget-error-wrapper">
      {!isFormGroup && formik.touched[name] && formik.errors[name] && (
        <span className="ui-widget-error">* {formik.errors[name]}</span>
      )}
    </div>
  );
};

export default InputError;
